jQuery.fn.customCheckbox = function() {
	$(this).each(function(i) {
		if ($(this).is('[type=checkbox],[type=radio]')) {
			var elmInput = $(this);

			// get the associated label using the input's id
			var elmLabel = $('label[for=' + elmInput.attr('id') + ']');

			//get type, for classname suffix
			var inputType = (elmInput.is('[type=checkbox]')) ? 'checkbox' : 'radio';

			// wrap the input + label in a div
			$('<div class="custom-' + inputType + '"></div>').insertBefore(elmInput).append(elmInput, elmLabel);

			// find all inputs in this set using the shared name attribute
			var allInputs = $('input[name=' + elmInput.attr('name') + ']');

            if(elmLabel.text().isEmpty) {
                elmLabel.addClass('no-text');
            }

			// necessary for browsers that don't support the :hover pseudo class on labels
//			elmLabel.hover(
//				function() {
//					elmLabel.addClass('hover');
//					if (inputType == 'checkbox' && elmInput.is(':checked')) {
//						elmLabel.addClass('checkedHover');
//					}
//				},
//				function() {
//					elmLabel.removeClass('hover checkedHover');
//				}
//			);

			// Disable text selection for IE
			elmLabel.bind('selectstart', function() {
				return false;
			});

			elmInput.click(function() {
				elmInput.trigger('updateState');
			});

/*			elmInput.focus(function() {
				elmLabel.addClass('focus');
				if (inputType == 'checkbox' && elmInput.is(':checked')) {
					elmInput.addClass('checkedFocus');
				}
			});

			elmInput.blur(function() {
				elmLabel.removeClass('focus checkedFocus');
			});*/

			//bind custom event, trigger it, bind click,focus,blur events
			elmInput.bind('updateState', function() {
				if (elmInput.is(':checked')) {
					if (elmInput.is(':radio')) {
						allInputs.each(function() {
							$('label[for=' + $(this).attr('id') + ']').removeClass('checked');
						});
					}
					elmLabel.addClass('checked');
				} else {
					elmLabel.removeClass('checked checkedHover checkedFocus');
				}
			});

			elmInput.trigger('updateState');
		}
	});
};

define("lib/jquery/jquery.customcheckbox", ["jquery"], function(){});

